import type { LucideIcon } from "lucide-react";
import { UserRoles } from "@/utils/constants";

export type NavItem = {
  key: string;
  label: string;
  icon: LucideIcon;
  route: string;
  /** Hidden until the viewer is logged in. */
  requiresAuth?: boolean;
  /** Hidden unless the viewer is a logged-in admin. */
  adminOnly?: boolean;
};

export type NavViewer = {
  isAuthenticated: boolean;
  isAdmin: boolean;
};

const ADMIN_ROLE_IDS: ReadonlySet<number> = new Set([
  UserRoles.HTP_ADMIN,
  UserRoles.LEAGUE_ADMIN,
  UserRoles.CUSTOMER_ADMIN,
]);

export function isAdminRole(roleId: number | undefined | null): boolean {
  return roleId != null && ADMIN_ROLE_IDS.has(roleId);
}

/**
 * The single place nav visibility is decided. Nav components render the
 * result and never re-check auth themselves.
 */
export function filterNavItems(
  items: readonly NavItem[],
  viewer: NavViewer
): NavItem[] {
  return items.filter((item) => {
    if (item.adminOnly) return viewer.isAuthenticated && viewer.isAdmin;
    if (item.requiresAuth) return viewer.isAuthenticated;
    return true;
  });
}
